module.exports = __webpack_public_path__ + "img/ball.88e0d67a.gif";